import React from 'react'
import { useRouteError, isRouteErrorResponse } from "react-router-dom";

export default function NotFoundPage() {
    const error = useRouteError();

    return (
        <div id="error-page">
            <h1>Oops!</h1>
            <p>Sorry, an unexpected error has occurred.</p>
            <p>
                { isRouteErrorResponse(error) &&  <i>{error.statusText}</i>}
            </p>
        </div>
    );
}
